exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".credit{background-color:#fd6c00;border-radius:6px;color:#fff;text-align:left;font-size:1.125rem;font-weight:500;padding-left:10px;padding-top:10px;padding-bottom:10px;margin-bottom:10px}@media (min-width:992px){.credit{font-size:1.25rem}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/creditsuccess/CreditSuccess.scss
 ** module id = 1237
 ** module chunks = 0
 **/